// -----------------------------------------------------------------------
// <copyright company="Microsoft Corporation">
// Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
// -----------------------------------------------------------------------

import type { IPlaybackApi, PlayState, SupportedPlaybackSpeed, UserTriggeredAction } from '../types/external';
import { ObservableProperty, Observable } from './observable';

export class ExternalPlayerApi implements IPlaybackApi {
  public readonly playState = new ObservableProperty<PlayState | undefined>(undefined);
  public readonly isPlayerReady = new ObservableProperty<boolean>(false);
  public readonly lastUserAction = new Observable<UserTriggeredAction>();
  public readonly currentTimeInSeconds = new ObservableProperty<number | undefined>(undefined);
  public readonly muted = new ObservableProperty<boolean | undefined>(undefined);
  public readonly volume = new ObservableProperty<number | undefined>(undefined);
  public readonly mediaDurationInSeconds = new ObservableProperty<number | undefined>(undefined);
  public readonly playbackSpeed = new ObservableProperty<SupportedPlaybackSpeed | undefined>(undefined);
  public readonly title = new ObservableProperty<string | undefined>(undefined);
  public readonly itemUrl = new ObservableProperty<string | undefined>(undefined);
  public readonly playerBeforeUnload = new Observable<boolean>();
}
